export default __webpack_public_path__ + "static/media/warmrock.b8aef731.png";